export default {
  hint: 'Customise the web address to apply your custom branding to your Programs and Storefront.',
  button: {
    reset: 'Reset to Fitr default',
    update: 'Update',
  },
};
